import {OPERATOR_COMPARAISON} from './operator.comparaison.model';

/**
 * Comparaisons offertes par une date, dans l'ordre où elles se présentent : « Le », « Pas le »,
 * « Avant ou le », « Après ou le », « Avant », « Après ».
 *
 * Ce sont les mêmes opérateurs qu'un nombre, mais pas dans le même ordre : une date se lit d'abord
 * par ses bornes inclusives, un nombre d'abord par le dessus. La liste de référence ne peut donc pas
 * servir ici, elle est réécrite.
 */
export const DATE_CONDITION_OPERATORS: OPERATOR_COMPARAISON[] = [
    OPERATOR_COMPARAISON.EQUALS,
    OPERATOR_COMPARAISON.NOT_EQUALS,
    OPERATOR_COMPARAISON.LOWER_OR_EQUALS,
    OPERATOR_COMPARAISON.GREATER_OR_EQUALS,
    OPERATOR_COMPARAISON.LOWER_THAN,
    OPERATOR_COMPARAISON.GREATER_THAN,
];
